
import DownloadIcon from '@/assets/svg/icons/download.svg';
import Vue from 'vue';
import { TransformedLmDownloads } from '~/transforms/transformModules';

export default Vue.extend({
  components: {
    DownloadIcon,
  },
  props: {
    data: {
      type: Object as () => TransformedLmDownloads['data'],
      required: true,
    },
  },
  methods: {
    getAssetInfo(linkObject: any) {
      const fileType = linkObject.filename.split('/')[7].split('.')[1].toUpperCase();
      return fileType;
    },
    checkHeadlineMargin() {
      if (this.data.moduleHeader && this.data.moduleHeader.headline) {
        const headlineText = this.data.moduleHeader.headline.text?.trim() ?? '';
        if (headlineText.length === 0) {
          return 'no-margin-top';
        }
      }
    },
  },
});
